// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"b1f5e5be","222":"8d23f66e","406":"f8015d1e","488":"6c9ff870"}[chunkId] + ".chunk.js";
};